// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c37a5f80","598":"8bbfabe3","703":"777f9dcc"}[chunkId] + ".chunk.js";
};